export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./RadioGroup.vue?vue&type=template&id=2a4338d8&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/RadioGroup.vue?vue&type=template&id=2a4338d8&
// module id = 1116
// module chunks = 0